<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    width="500px"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      ref="brandForm"
      label-width="110px"
      :rules="formValidate"
    >
      <el-form-item label="用户名" prop="nick">
        <el-input v-model="form.nick" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="cellphone">
        <el-input v-model="form.cellphone" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          v-model="form.password"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email" class="logo">
        <el-input v-model="form.email" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="form.type">
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓单用户">
        <el-switch
          v-model="form.warehouseReceiptUser"
          active-text="是"
          inactive-text="否"
        ></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSumbit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import { CONST_VD_IMGPREFIX } from "@/config/constant";

export default {
  props: {
    show: Boolean,
    currentBrand: Object,
  },
  data() {
    return {
      types: [
        { label: "超级用户", value: "0" },
        { label: "员工", value: "1" },
        { label: "合作伙伴", value: "2" },
      ],
      brandId: 0,
      currentKey: "",
      form: this.getInitForm(),
      formValidate: {
        nick: [{ required: true, trigger: "blur", message: "请填写用户名" }],
        cellphone: [
          { required: true, trigger: "blur", message: "请输入手机号" },
        ],
        email: [{ required: true, trigger: "blur", message: "请填写邮箱号" }],
        type: [{ required: true, trigger: "blur", message: "请选择类型" }],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
      },
      title: "编辑用户",
      uploadData: {
        _aid: 401,
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    getInitForm() {
      return {
        nick: "",
        cellphone: "",
        email: "",
        password: "",
        type: "1",
        warehouseReceiptUser: false,
      };
    },
    handleCancel() {
      this.$emit("update:show", false);
    },
    handleSumbit() {
      this.$refs["brandForm"].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("omsUserAddOrModify", {
              omsUserEntity: {
                ...this.form,
                id: this.currentBrand ? this.currentBrand.id : null,
              },
            })
            .then((res) => {
              if (res.isSuccess) {
                this.$emit("on-submit");
                this.$message.success("添加成功");
              } else {
                this.$message.error(res.resultMessage || "添加失败");
              }
            })
            .catch((error) => {
              this.$message.error(error.msg || error.message || "提交失败");
            });
        } else {
          this.$message.error("信息不完善");
        }
      });
    },
    // handleSuccess(res, file) {
    //   this.$message.success("上传成功");
    //   this.form.logoImgName =
    //     CONST_VD_IMGPREFIX + res.content[0]["CPRODUCT_IMG.jpg"];
    // },
    handleSuccess(res, file, name) {
      this.$message.success("上传成功");
      this.form[this.currentKey] =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0]["CPRODUCT_IMG.jpg"];
    },
    handleError(res) {
      this.$message.error("上传失败");
    },
    changeUpdateKey(key) {
      this.currentKey = key;
    },
  },
  watch: {
    show(val) {
      if (val) {
        if (this.$refs["brandForm"]) {
          this.$refs["brandForm"].clearValidate();
        }
        this.brandId = !isEmpty(this.currentBrand)
          ? this.currentBrand.brandId
          : 0;
        const id = !isEmpty(this.currentBrand) ? this.currentBrand.id : 0;
        if (id) {
          this.title = "编辑用户";
          this.form = {
            brandName: this.currentBrand.brandName,
            otherName: this.currentBrand.brandForeignName,
            logoImgName: this.currentBrand.brandLogo,
            nationId: this.currentBrand.nationId
              ? this.currentBrand.nationId
              : "",
            sourceId: this.currentBrand.sourceId
              ? this.currentBrand.sourceId
              : "",
            tradeMarkPaper: this.currentBrand.tradeMarkPaper,
            certificateOfAuthorization:
              this.currentBrand.certificateOfAuthorization,
            procurementChain: this.currentBrand.procurementChain,
            customUpload: this.currentBrand.customUpload,
          };
        } else {
          this.title = "新增用户";
          this.form = this.getInitForm();
        }
      }
    },
  },
};
</script>

<style></style>
